import React, { PropsWithChildren, useContext, useMemo } from 'react';

import { Episode, TEpisode } from '~/src/common/lean-back';

type Value = Episode;

const EpisodeContext = React.createContext<Value | undefined>(undefined);

type Props = { episode: TEpisode };

export const EpisodeProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  episode: episodeDetails,
}) => {
  const episode = useMemo(() => {
    return new Episode(episodeDetails);
  }, [episodeDetails]);

  return <EpisodeContext.Provider value={episode}>{children}</EpisodeContext.Provider>;
};

export function useEpisode() {
  const context = useContext(EpisodeContext);
  if (typeof context === 'undefined') {
    throw new Error('useEpisode must be used within a EpisodeContext');
  }
  return context;
}
